import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'

import API from '../../services/API'
import Segment from '../../components/Segment'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    description: '',
    active: true,
}

const CustomerTypesEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const disabled = !data.name || !data.description

    

    const getData = () => {
        setloading(true)
        API.get(`/api/categories/${match.params.id}`)
            .then(response => {
                setData(response.data)
                setloading(false)
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.patch(`/api/categories/${match.params.id}`, data)
            .then(() => {
                setloading(false)
                notification.success({
                    message: 'El categoría se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Editar la categories</Divider>

            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>

                <Form.Item label="Nombre" className="required" hasFeedback>
                    <Input
                        placeholder="Nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripición" className="required" hasFeedback>
                    <Input
                        placeholder="Descripición"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>


                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/categories">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>

              
            </Form>
        </Segment>
    )
}

export default CustomerTypesEditContainer
